import React from 'react'
import InsetWrapper from '../wrappers/inset-wrapper'
import { IconType } from 'react-icons'
import { Icon, IconProps, Tooltip } from '@chakra-ui/react'
import SharedStack from '../wrappers/shared-stack'

interface Props {
    icon: IconType
    tooltip?: React.ReactNode
    value: number
    iconProps?: IconProps
}

export default function StatCircle({ icon, tooltip, value, iconProps }: Props) {
    return (
        <Tooltip fontSize="xs" label={tooltip} shouldWrapChildren>
            <SharedStack
                as={InsetWrapper}
                rounded="full"
                alignItems="center"
                justifyContent="center"
                fit
                p={1}
            >
                <Icon boxSize="14px" as={icon} {...iconProps} />
            </SharedStack>
        </Tooltip>
    )
}
